module.exports = __webpack_public_path__ + "img/terra-2-small.7a9ded52.svg";